const path404 = (localeCountry, testId) => (`${localeCountry}/${testId}/404`);

const route404 = (next, localeCountry) => (next({ name: 'NotFound', params: { localeCountry } }));

export {
  path404,
  route404,
};
